import { SEPOLIA } from "./sepolia.js";
import { POLYGON } from "./polygon.js";
export const CHAINS = [SEPOLIA, POLYGON];
export { SEPOLIA, POLYGON };
